import React from 'react';
import SummarySectionLineItem from './SummarySectionLineItem'

export default function SummarySectionDisplay({
	title,
	items,
	edit,
	showEdit,
	status,
	isMobileOnly,
	sectionPhase,
	phaseHistory
}){

	let normalizedPhaseHistory = Array.isArray(phaseHistory) ? phaseHistory : [];
	let hasVisitedPhase = sectionPhase ? normalizedPhaseHistory.indexOf(sectionPhase) !== -1 : false;

	let handleEdit = () => {
		if (typeof edit === "function"){
			// Keep existing edit callback compatibility while exposing visit metadata.
			edit(sectionPhase, {hasVisitedPhase});
		}
	}

	return(<div class="col-12 col-md-6 px-0 float-left">
		<div class="card">
			<div class="card-body">

				<div class="col-12 mt-2 pb-3 px-0 clearfix">
					<div class="col-12 pl-1 mb-2 clearfix border-bottom">
						<p class="mt-4 mb-1 fs-20 float-left">{title}</p>
						{showEdit ? <button type="button" className={
							isMobileOnly ? "btn btn-xs btn-round btn-secondary fs-12 mb-3 ml-4 px-4 float-right" :
							"btn btn-xs btn-round btn-secondary fs-12 mt-4 mb-3 ml-4 px-4 float-right" 
						}
						onClick={handleEdit}>
							Edit
						</button> : null}
					</div>

					{items && items.length ? items.map(({label, value, type, customEmptyState, emptyStateOverride, detectCapitalizationIssues}, index) => {
						let hasEmptyStateOverride = emptyStateOverride !== undefined;
						return <SummarySectionLineItem
							key={index}
							label={label}
							value={value}
							type={type}
							detectCapitalizationIssues={detectCapitalizationIssues}
							showEdit={showEdit}
							hasVisitedPhase={hasVisitedPhase}
							edit={handleEdit}
							disableEmptyStateAction={hasEmptyStateOverride}
							emptyStateString={
								hasEmptyStateOverride ? emptyStateOverride :
								(customEmptyState !== undefined ? customEmptyState :
								(status === "setup" ? (hasVisitedPhase ? "Not yet entered" : "Not started yet") : "None entered")
								)
							}
						/>
					}) : "Nothing to display..."}

				</div>
			</div>
		</div>
	</div>)

}